export enum StatusApiCode {
  'LOADING',
  'DONE',
  'ERROR'
}

export class StatusApi {
  private code: StatusApiCode;
  private message?: string;
  constructor() {
    this.code = StatusApiCode.DONE;
  }
  isLoading() {
    return this.code === StatusApiCode.LOADING;
  }
  isDone() {
    return this.code === StatusApiCode.DONE;
  }
  isError() {
    return this.code === StatusApiCode.ERROR;
  }
  getError() {
    return this.message;
  }
  setLoading() {
    this.code = StatusApiCode.LOADING;
  }
  setError(message: string) {
    this.code = StatusApiCode.ERROR;
    this.message = message;
  }
  setDone() {
    this.code = StatusApiCode.DONE;
    delete this.message;
  }
}

export enum EstadoProgresoFichero {
  INICIO,
  COMENZADO,
  FINALIZADO,
  ERROR
}
export interface ProgresoFichero {
  estado: EstadoProgresoFichero,
  cargado: number,
  total: number,
}
export class ProgresoFichero {
  private _progreso: number = 0;
  get progreso() {
    return this._progreso;
  }
  get esIniciado() {
    return this.estado === EstadoProgresoFichero.COMENZADO;
  }
  get esFinalizado() {
    return this.estado === EstadoProgresoFichero.FINALIZADO;
  }
  get esError() {
    return this.estado === EstadoProgresoFichero.ERROR;
  }
  constructor() {
    this.inicializarProgreso();
  }
  private calcularProgreso() {
    this._progreso = Math.round((100 * this.cargado) / this.total);
  }
  inicializarProgreso() {
    this.estado = EstadoProgresoFichero.INICIO;
    this.cargado = 0;
    this.total = 0;
    this._progreso = 0;
  }
  comenzarProgreso() {
    this.actualizarProgreso(0,0);
    this.estado = EstadoProgresoFichero.COMENZADO;
  }
  actualizarProgreso(cargado: number, total: number) {
    this.cargado = cargado;
    this.total = total;
    this.calcularProgreso();
  }
  finalizarProgreso() {
    this.estado = EstadoProgresoFichero.FINALIZADO;
  }
  actualizarError() {
    this.estado = EstadoProgresoFichero.ERROR;
  }
  
}
